<template>
  <main
    v-if="!!state"
    :class="[
      { 'btn-primary': state === 'primary' },
      { 'btn-secondary': state === 'secondary' },
    ]"
  >
    <p class="-stb">{{ title }}</p>
  </main>
</template>

<script>
export default {
  props: ["state", "title"],
};
</script>

<style scoped>
.btn-primary,
.btn-secondary {
  border-radius: 4px;
  padding-inline: 16px;
  padding-block: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  user-select: none;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 200ms ease;
}

.btn-primary {
  background: var(--secondary);
}
.btn-secondary {
  background: var(--white1);
}
.btn-primary:hover,
.btn-secondary:hover {
  transform: scale(1.1);
}
</style>